import { MAlert } from "@material-dev/insights-portal-ui-components";
import { useStyles } from "./CompareVersionAlertsStyles";
import { CompareVersionValidationResult } from "./types";

type CompareVersionAlertsProps = {
  errors?: CompareVersionValidationResult[];
};

const CompareVersionAlerts = ({ errors }: CompareVersionAlertsProps) => {
  const { classes, cx } = useStyles();

  return (
    <div className={classes.root}>
      {errors?.map(({ severity, text }) => {
        return (
          <MAlert
            className={cx(
              classes.alert,
              severity === "error" && classes.error,
              severity === "warning" && classes.warning,
            )}
            severity={severity}>
            {text}
          </MAlert>
        );
      })}
    </div>
  );
};
export default CompareVersionAlerts;
